import { Constants } from '.';

export function getOptionName(optionId: number, options: any[]): string {
  if (optionId === null || optionId === undefined) {
    return null;
  }

  const option = getOptionFor(optionId, options);

  if (
    option === null ||
    option === undefined ||
    Constants.DropDownOption.chooseOption === option.name
  ) {
    return null;
  }

  return option.name;
}

export function getOptionId(option: any): number {
  if (!option || Constants.DropDownOption.chooseOption === option.name) {
    return null;
  }

  return option.id;
}

export function getOptionFor(optionId: number, options: any[]): any {
  if (!options) {
    return null;
  }

  return options.find((x) => x.id === optionId);
}

export function createOptionsFromArray(
  array: any[],
  hasChooseOption: boolean,
  hasChooseOptionText: string
): { id: number; name: string }[] {
  const result = (array || []).map((x) => ({
    id: x.id,
    name: x.value,
  }));

  if (hasChooseOption) {
    result.splice(0, 0, {
      id: -1,
      name: hasChooseOptionText || Constants.DropDownOption.chooseOption,
    });
    // used for inserting the hasChooseOptionText or None option in the dropdown
  }

  return result;
}
